import { Button, Card, Col, Dropdown, Image, Row, Tag, Tooltip } from "antd";
import {
  AmountIcon,
  GreenCheckIcon,
  PenIcon,
  PlusIcon,
  StarFilledIcon,
} from "../../../../atoms/CustomIcons";
import { PopUp } from "../../../../atoms/PopUp";
import AddContactPopUp from "./PopUp";
import { useRef, useState } from "react";
import ConfirmDelete from "../../../../atoms/ConfirmDelete";
import { PhoneInput } from "react-international-phone";
import { MoreOutlined } from "@ant-design/icons";

interface PropsType {
  contacts: PopUpFormValues[];
  setContacts: React.Dispatch<React.SetStateAction<PopUpFormValues[]>>;
}

interface PopUpFormValues {
  first_name: string;
  last_name: string;
  phone: string;
  email: string;
  title: string;
  preferred_method_of_contact: string;
}

export default function AddContact(props: PropsType) {
  const { setContacts, contacts } = props;
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [contactIndex, setContactIndex] = useState<null | number>(null);
  const [tableRecord, setTableRecord] = useState<null | PopUpFormValues>(null);
  const dropdownRef = useRef<HTMLButtonElement>(null);

  const myContactPopup = {
    visibility: isModalOpen,
    content: (
      <AddContactPopUp
        onClose={() => {
          setIsModalOpen(false);
          setContactIndex(null);
        }}
        setContacts={setContacts}
        contactIndex={contactIndex}
        setContactIndex={setContactIndex}
        contacts={contacts}
        editData={contactIndex !== null ? contacts?.[contactIndex] : null}
      />
    ),
    width: 541,
    onCancel: () => setIsModalOpen(false),
  };

  const items = [
    {
      key: "1",
      label: (
        <Button
          type="text"
          className="no-hover"
          onClick={(e) => {
            e.stopPropagation();
            setIsModalOpen(true);
            if (dropdownRef.current) {
              dropdownRef?.current?.click(); // Simulate a click to close
            }
          }}
        >
          Edit details
        </Button>
      ),
    },
    {
      key: "2",
      label: (
        <Button
          type="text"
          className="delete-hover"
          onClick={() => {
            setIsDeleteModalOpen(true);
            if (dropdownRef.current) {
              dropdownRef?.current?.click(); // Simulate a click to close
            }
          }}
        >
          Delete
        </Button>
      ),
    },
  ];

  console.log("contactIndex", contactIndex);

  const deleteFunction = () => {
    if (contactIndex !== null) {
      if (contactIndex < 0 || contactIndex >= contacts.length) {
        setContactIndex(null); // Clear the invalid index state
        return;
      }
      try {
        const updatedContacts = [
          ...contacts.slice(0, contactIndex),
          ...contacts.slice(contactIndex + 1),
        ];

        setContacts(updatedContacts);
        setIsDeleteModalOpen(false);
        setContactIndex(null);
      } catch (error) {
        console.error("Error deleting contact:", error);
      }
    } else {
      return;
    }
  };

  const deleteContactPopUp = {
    visibility: isDeleteModalOpen,
    content: (
      <ConfirmDelete
        title=""
        onClose={() => setIsDeleteModalOpen(false)}
        heading="Confirm deletion"
        paragraph={
          <>
            Are you sure you want to delete{" "}
            <b>{`${tableRecord?.first_name} ${tableRecord?.last_name}`}</b>?
            <br />
            <br />
            This action cannot be undone.
          </>
        }
        btnText="Delete contact"
        btnApi={deleteFunction}
        loading={false}
      />
    ),
    width: 480,
    onCancel: () => setIsDeleteModalOpen(false),
  };

  const tagClassNames = [
    "mint_tag",
    "red_tag",
    "orange_tag",
    "purple_tag",
    "pink_tag",
    "violet_tag",
    "blue_tag",
    "yellow_tag",
  ];

  return (
    <Row gutter={20}>
      <Col span={24}>
        <h4 style={{ marginBottom: "4px" }}> Contacts </h4>
        <p style={{ marginBottom: "16px" }}>
          People on the subcontractor’s side your team works and collaborates
          with.
        </p>

        {contacts?.length > 0 && (
          <Button
            type="primary"
            className="outlined-btn"
            icon={<PlusIcon style={{ color: "#151718" }} />}
            onClick={() => setIsModalOpen(true)}
            style={{ position: "absolute", right: "10px", top: "0px" }}
          />
        )}
      </Col>
      <Col span={24}>
        <div className="contact_wrapper">
          {contacts?.length > 0 ? (
            contacts?.map((e, i) => {
              const randomIndex = Math.floor(
                Math.random() * tagClassNames.length
              );
              const randomClassName = tagClassNames[randomIndex];
              return (
                <Card>
                  <div className="titleBar">
                    <span className="userName">
                      {`${e?.first_name} ${e?.last_name}`}
                    </span>
                    <div className="actionBtns">
                      <Button type="text">
                        <StarFilledIcon />
                      </Button>
                      <Button type="text">
                        <PenIcon />
                      </Button>
                      <Button type="text">
                        <AmountIcon />
                      </Button>

                      <Dropdown
                        menu={{ items }}
                        trigger={["click"]}
                        placement="bottomRight"
                        className="actionButton"
                      >
                        <Button
                          onClick={(x) => {
                            x.stopPropagation();
                            setContactIndex(i);
                            setTableRecord(e);
                          }}
                          onKeyDown={(e) => e.stopPropagation()}
                          style={{
                            padding: "0px",
                            height: "auto",
                            border: "unset",
                            backgroundColor: "transparent",
                          }}
                          ref={dropdownRef}
                          className="only_icon"
                          icon={<MoreOutlined />}
                        />
                      </Dropdown>
                    </div>
                  </div>
                  <div style={{ marginBottom: "20px" }}>
                    {e?.title && (
                      <div style={{ marginBottom: "20px" }}>
                        <Tag
                          className={randomClassName}
                          style={{
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            display: "inline-block",
                            minWidth: "auto",
                            maxWidth: "100%",
                          }}
                        >
                          {e?.title}{" "}
                        </Tag>
                      </div>
                    )}
                  </div>
                  <div className="contactData">
                    <span className="labelText">Phone:</span>
                    <span className="ValueText">
                      {e?.phone ? (
                        <>
                          <PhoneInput disabled value={e?.phone} />
                          {e?.preferred_method_of_contact === "phone" && (
                            <GreenCheckIcon />
                          )}
                        </>
                      ) : (
                        "-"
                      )}
                    </span>
                  </div>

                  <div className="contactData">
                    <span className="labelText">Email:</span>
                    <span className="ValueText">
                      {e?.email ? (
                        <>
                          <span className="truncatedEmail">
                            <Tooltip title={e.email}>
                              {e.email.length > 22
                                ? `${e.email.slice(0, 22)}...`
                                : e.email}
                            </Tooltip>
                          </span>
                          {e?.preferred_method_of_contact === "email" && (
                            <GreenCheckIcon
                              style={{
                                marginLeft: "4px",
                              }}
                            />
                          )}
                        </>
                      ) : (
                        "-"
                      )}
                    </span>
                  </div>
                </Card>
              );
            })
          ) : (
            <div className="whenEmpty">
              <Image src="/images/empty-icons/no-active.svg" preview={false} />
              <h3> There are no contacts </h3>
              <p> Click “+” to add a contact to this subcontractor. </p>
              <Button
                type="primary"
                className="outlined-btn btn-sm white_icon_btn"
                icon={<PlusIcon style={{ color: "#151718" }} />}
                onClick={() => setIsModalOpen(true)}
              >
                Add contact
              </Button>
            </div>
          )}

          <PopUp {...myContactPopup} />
          <PopUp {...deleteContactPopUp} />
        </div>
      </Col>
    </Row>
  );
}
